import { render, staticRenderFns } from "./SmallMegaMenu.vue?vue&type=template&id=4d144fa9"
import script from "./SmallMegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallMegaMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports